<template>
  <div>
    <page-header :title="pageTitle" />
    <page-body>
      <el-row>
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-row>
            <el-col :span="4">
              <el-button type="primary" size="medium" style="margin-left:8px; border-radius: 4px; background: #327dff;" @click="addUpdateHandle()">
                新建
              </el-button>
              <el-button type="primary" size="medium" style="margin-left:8px; border-radius: 4px; background: #327dff;" @click="handleSearch">
                查询
              </el-button>
            </el-col>
            <el-col :span="25" sortable="false">
              <el-form-item label="所属平台用户" prop="account_id" class="search-item">
                <el-cascader
                  placeholder="所属平台用户"
                  v-model="searchForm.account_id"
                  :options="options"
                  :props="{emitPath: false, expandTrigger: 'hover' }"
                  filterable
                  clearable  />
              </el-form-item>
              <el-form-item label="远程账户" prop="username" class="search-item">
                <el-input v-model="searchForm.username" style="width:220px" clearable />
              </el-form-item>
              <el-form-item label="服务器IP" prop="hostname" class="search-item">
                <el-input v-model="searchForm.hostname" style="width:220px" clearable />
              </el-form-item>
              <el-form-item label="状态" prop="is_lock" class="search-item">
                <el-select v-model="searchForm.is_lock" clearable placeholder="" style="width:180px">
                  <el-option v-for="stat in is_lock" :key="stat.id" :label="stat.name" :value="stat.id" clearable />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-row>
      <el-row>
        <el-table :data="dataSource" border empty-text="暂无数据">
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <div class="button-container">
                <el-button type="text" @click="updataedit(scope.row)">修改</el-button>
                <el-button type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                <el-button type="text" @click="folderUp(scope.row)">私有文件夹</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="ID" width="60px" />
          <el-table-column prop="account_id" label="所属平台用户" width="120" align="left">
            <template slot-scope="scope">
              <span>
                {{ getUserName(scope.row.account_id) }}
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="remote_name" label="服务器名" width="260px" align="left" /> -->
          <el-table-column prop="remote_name" label="服务器名" align="left" width="260">
            <template slot-scope="scope">
              <span>{{ scope.row.remote_name }}</span>
              <span style="margin-left: 10px;color:#e3763e;">(在线用户:{{ scope.row.count || 0 }})</span>
            </template>
          </el-table-column>
          <el-table-column prop="hostname" label="服务器IP" width="150"  align="left" />
          <el-table-column prop="port" label="端口" width="80"   align="left" />
          <el-table-column prop="username" label="远程账户" width="120"  align="left" />
          <el-table-column prop="is_lock" align="center" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.is_lock == 0">正常</el-tag>
              <el-tag v-else type="info">异常</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" align="left" width="170">
            <template slot-scope="scope">
              {{ formatTimestamp(scope.row.created_time) }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注"  align="left" />
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="pageSizeList"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total" />
      </el-row>
    </page-body>
    <!-- 弹窗, 新增 -->
    <add-update ref="AddUpdate" @onSubmit="getDataList" />
    <!-- 弹窗, 编辑 -->
    <edit-update ref="EditUpdate" @onSubmit="getDataList" />
    <!-- 弹窗, 文件夹 -->
    <folder-update ref="FolderUpdate" @onSubmit="getDataList" />
</div>
</template>

<script>
import { MessageBox, Message } from 'element-ui'
import { eventBus } from '@containers/WinRD/utils/eventBus' // 全局事件总线
import PageBody from '~/components/PageBody/index.vue'
import PageHeader from '~/components/PageHeader/index.vue'
import AddUpdate from './add-update'
import EditUpdate from './edit-update'
import FolderUpdate from './folder-update'

export default {
  name: 'myspace',
  components: {
    PageHeader,
    PageBody,
    AddUpdate,
    EditUpdate,
    FolderUpdate,
  },
  data () {
    return {
      pageTitle: '用户账号管理',
      searchForm: { },
      linkUserList: [],
      options: [],
      is_lock: [
        { id: 0, name: '正常' },
        { id: 1, name: '异常' },
      ],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      dataSource: [],
      timer: null,
      pageSizeList: [10, 20, 50, 100],
    }
  },
  created () {
    // 监听事件
    eventBus.$on('refresh-list', this.fetchData)
    this.linkUser()
  },
  mounted () {
    console.log('Mounted hook called, calling fetchData')
    this.fetchData()
  },
  beforeDestroy () {
    // 移除事件监听
    eventBus.$off('refresh-list', this.fetchData)
    // 在组件销毁前停止定时器
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    // 列表获取
    async fetchData () {
      console.log('fetchData method called')
      try {
        if (!this.pagination) {
          console.error('this.pagination is not defined')
          return
        }

        const dataRaw = {
          account_id: this.searchForm.account_id,
          username: this.searchForm.username,
          hostname: this.searchForm.hostname,
          is_lock: this.searchForm.is_lock,
          page: this.pagination.currentPage,
          per_page: this.pagination.pageSize,
        }

        console.log('About to make API request to /rdbackend/list_users')
        console.log('Request parameters:', dataRaw)
        const response = await this.$http.get('/rdbackend/list_users', {
          params: dataRaw,
        })
        console.log('API request successful, response:', response.data)

        const overViewListData = response.data
        this.dataSource = overViewListData.users || []
        this.pagination.total = overViewListData.count || 0
        this.pagination.currentPage = overViewListData.page || 1

        // 获取每个服务器的请求接口数量 并10秒刷新
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        } else {
          this.timer = setInterval(() => {
            this.fetchApiCounts()
          }, 10000)
        }
      } catch (error) {
        console.error('There was an error!', error)
      }
    },
    // 获取每个服务器的请求接口数量
    async fetchApiCounts () {
      try {
        const response = await this.$http.get('/rdbackend/connections')
        const res = response.data.data
        for (let i = 0; i < this.dataSource.length; i++) {
          const item = this.dataSource[i]
          for (let j = 0; j < res.length; j++) {
            if (item.remote_name === res[j].name) {
              this.$set(item, 'count', res[j].count)
            }
          }
        }
      } catch (error) {
        console.error('There was an error fetching API counts!', error)
      }
    },

    // 获取所属用户
    async linkUser () {
      try {
        // 发送 GET 请求获取用户数据
        const response = await this.$http.get('/rdbackend/get_users')

        // 确保 response.data 是一个数组
        this.linkUserList = Array.isArray(response.data.data) ? response.data.data : []

        // 处理 options 数据
        this.options = this.linkUserList.map(domain => ({
          value: domain.domain_id, // 平台 ID
          label: domain.project_domain, // 平台名称
          children: domain.user ? domain.user.map(user => ({
            value: user.id, // 用户 ID
            label: user.displayname || user.name, // 用户名称
          })) : [], // 如果没有用户，则 children 为空数组
        }))
      } catch (error) {
        console.error('There was an error!', error)
      }
    },
    getUserName (accountId) {
      const user = this.findUserById(accountId)
      return user ? user.label : ' '
    },
    findUserById (accountId) {
      for (const domain of this.options) {
        for (const user of domain.children) {
          if (user.value === accountId) {
            return user
          }
        }
      }
      return null
    },

    // 查询
    handleSearch () {
      this.pagination.currentPage = 1
      this.fetchData()
    },

    // 分页
    handleSizeChange (val) {
      // 改变每页显示的条数
      this.pagination.pageSize = val
      this.fetchData(this.pagination.currentPage, this.pagination.pageSize)
    },

    handleCurrentChange (val) {
      // 改变默认的页数
      this.pagination.currentPage = val
      this.fetchData(this.pagination.currentPage, this.pagination.pageSize)
    },

    // 新增
    addUpdateHandle (row) {
      this.$refs.AddUpdate.init({ ...row }, this.appTypeList)
    },

    // 修改
    updataedit (row) {
      this.$refs.EditUpdate.init({ ...row }, this.appTypeList)
    },

    // 编辑文件夹
    folderUp (row) {
      this.$refs.FolderUpdate.init({ ...row }, this.appTypeList)
    },

    // 删除
    handleDelete (idx, row) {
      MessageBox('您确定删除用户' + row.username + '吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          host_id: row.host_id,
          username: row.username,
          action: 'delete',
        }

        this.$http.post('/rdbackend/delete_user', params, {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then(resp => {
          this.fetchData() // 更新用户列表
          if (resp.data.code === 200) {
            const message = resp.data.message
            Message({
              message,
              type: 'success',
            })
          } else {
            Message({
              message: '删除失败: ' + resp.data.errmsg,
              type: 'error',
            })
          }
        }).catch(error => {
          console.error('Error deleting user:', error)
          Message({
            message: '删除失败: ' + error.message,
            type: 'error',
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },

    // 转换时间戳
    formatTimestamp (timestamp) {
      if (timestamp) {
        const date = new Date(timestamp * 1000) // 将秒转换为毫秒
        return date.toLocaleString() // 返回本地化的日期和时间字符串
      }
      return ''
    },

    // 子组件提交后刷新数据
    getDataList () {
      this.fetchData()
    },
  },
}
</script>

<style scoped>
body,html{
  min-width: 1280px;
}
.el-table thead{
  color: #333 !important;
  font-weight: bold !important;
}
.el-button{
  float: left;
  margin-right: 10px;
}
.el-tag {
  margin-right: 10px;
  margin-bottom: 5px;
}
.el-tag:last-child {
  margin-right: 0;
  margin-bottom: 0;
}
.el-tag{
  border: 0;
  color: #606266;
  background: rgba(0, 0, 0, 0);
}
.el-tag.el-tag--info{
  border: 0;
  color: #606266;
  background: rgba(0, 0, 0, 0);
}
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.button-container .el-button {
  margin: 0 5px; /* 可选：为按钮添加一些间距 */
}
.el-table th.el-table__cell>.cell{
  color: #333 !important;
}
</style>
